import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=4b46098e&scoped=true&"
import script from "./OrderAddress.vue?vue&type=script&lang=js&"
export * from "./OrderAddress.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=4b46098e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46098e",
  null
  
)

export default component.exports